import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {ValidationService} from '../service/validation-service';
import {ControlMessageComponent} from './control-message.compoenent';

@NgModule({
  imports:[
    CommonModule,FormsModule
  ],
  declarations: [
    ControlMessageComponent
  ],
  providers: [ValidationService],
  exports: [ ControlMessageComponent ]
})
export class ControlMessageModule {

}
